export const BASE_URL = 'https://api.nazar.cloud';
export const API_VERSION = 'v1';
export const API_URL = `${BASE_URL}/api/${API_VERSION}`;
export const STORAGE_URL = `${BASE_URL}/storage/`;

export const AWS_S3_URL = 'https://nazar-cloud-084828605627-eu-north-1-an.s3.eu-north-1.amazonaws.com/';